import type { PricelistPeriod } from "@/generated/graphql";
import {
	Autocomplete,
	type AutocompleteFetcher,
	Button,
} from "@k3-tech/react-kit";
import { PencilIcon } from "lucide-react";

export default function PricelistPeriodAutocomplete({
	initialPricelistPeriod,
	autocompleteFetcher,
	onClickManagePeriod,
	onSelectPricelistPeriod,
}: {
	initialPricelistPeriod?: PricelistPeriod;
	autocompleteFetcher: AutocompleteFetcher;
	/** Omitted where the Periods tab already manages them. */
	onClickManagePeriod?: () => void;
	onSelectPricelistPeriod: (pricelistPeriodID: string) => void;
}) {
	return (
		<div className="flex gap-x-4">
			<Autocomplete
				mode="server"
				options={[]}
				fetcher={autocompleteFetcher}
				initialSelectedOptions={
					initialPricelistPeriod
						? [
								{
									label: initialPricelistPeriod.pricelistPeriodName,
									value: initialPricelistPeriod.pricelistPeriodID,
								},
							]
						: []
				}
				defaultValue={initialPricelistPeriod?.pricelistPeriodID}
				onChange={(value) => {
					onSelectPricelistPeriod(value as string);
				}}
			/>
			{onClickManagePeriod ? (
				<Button onClick={onClickManagePeriod}>
					<PencilIcon />
					<span>Manage Period</span>
				</Button>
			) : null}
		</div>
	);
}
